import React from 'react';
import { Button, Icon } from './styles';

export default ({ onClick, label }) => {
    return (
        <Button onClick={onClick}>
            <Icon/>{label}
        </Button>
    );
};